module.exports = __webpack_public_path__ + "static/media/fav-item-selected.73bb3979.svg";